import React from "react";
import styles from "./ProductImage.module.scss";

const ProductImage = (props) => {
  const { sku } = props;

  const imagePath = sku && `/images/products/${sku.toUpperCase()}.jpg`

  return (
    <div className={styles.module}>
      <img src={imagePath} alt={sku} />
    </div>
  );
}

export default ProductImage;